<template>
    <div class="blog">
        <h2 class="componentheader" id="top">Blog</h2>
        <p>Check out the latest blog posts.</p>
        <div class="postContainer">
          <div class="postBody thumbnails card"
            v-for="(blogPost, index) in blogPosts"
            :key="blogPost.id"
            @click="showModal(index)"
          >
            <div class="card-body">
              <h4 class="card-title" :id="blogPost.id">{{ blogPost.title }}</h4>
              <p>{{ blogPost.date }}</p>
              <p class="card-text">{{ blogPost.summary }}</p>
            <!-- <h2 class="blogTitle">{{ blogPost.title }}</h2>
            <div class="blogDate">{{ blogPost.date }}</div>
            <div class="blogBody" v-html="blogPost.blogBody"> -->
                <!-- {{ blogPost.blogBody }} -->
            </div>
          </div>
        </div>
        <blogModal v-model="modalShow"
        :selectedPost="selectedPost"></blogModal>
    </div>
</template>

<script>

import db, { Timestamp } from '@/db'
import blogModal from '@/components/blogModal.vue'

export default {
  name: 'Blog',
  components: {
    blogModal
  },
  data () {
    return {
      modalShow: false,
      selectedPost: {},
      blogPosts: []
    }
  },
  created () {
    var serverTime = Timestamp.fromDate(new Date())
    db.collection('blogPosts').where('date', '<=', serverTime).orderBy('date', 'desc').get().then(snapshot => {
      snapshot.forEach(doc => {
        const id = doc.id
        const title = doc.data().title
        const blogBody = doc.data().blogBody
        var date = doc.data().date
        const summary = doc.data().summary
        const options = {
          year: 'numeric', month: 'long', day: 'numeric'
        }
        date = new Intl.DateTimeFormat('en-US', options).format(date.seconds * 1000)

        const post = {
          id,
          title,
          blogBody,
          date,
          summary
        }

        this.blogPosts.push(post)
      })
    })
  },
  methods: {
    showModal: function (index) {
      this.selectedPost = this.blogPosts[index]
      console.log(this.selectedPost)
      this.modalShow = !this.modalShow
    }
  }
}
</script>

<style scoped>
.container-wrapper {
  margin: auto;
  text-align: center;
}
.postContainer {
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
}
.thumbnails {
  width: 100%;
  margin-bottom: .5em;
  display: inline-block;
  padding: .5em;
}
.thumbnails:hover, .thumbnails:focus {
  transform: scale(1.05);
  transition-duration: .5s;
  cursor: pointer;
}
@media screen and (min-width: 768px) {
  .thumbnails {
    width: 49%;
  }

  div.thumbnails:nth-child(odd) {
    margin-right: 2%;
  }
}
@media screen and (min-width: 1024px) {
  .thumbnails {
    width: 32%;
  }
  div.thumbnails:nth-child(3n) {
    margin-right: 0;
  }
  div.thumbnails:nth-child(3n-2),div.thumbnails:nth-child(3n-1) {
    margin-right: 2%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Blog.vue